import * as actionType from "../constants";

const initialState = {
  notes: [],
  board: false,
  message: "",
  title: "",
  users: [],
  code: "",
  isAdding: false,
};

export const AddNoteBoard = (state = initialState, action) => {
  if (action.type === actionType.POPUP_STOP_DETAILS) {
    return { ...state, board: false, message: "", title: "", code: "" };
  }
  if (action.type === actionType.NOTE_ADDING) {
    return { ...state, isAdding: true };
  }
  if (action.type === actionType.NOTE_ADDED) {
    return { ...state, isAdding: false };
  }
  if (action.type === actionType.CLEAR_NOTE) {
    return {
      ...state,
      notes: [],
    };
  }
  if (action.type === actionType.ADD_NOTE_BOARD) {
    const newboard = [...state?.notes];
    newboard.unshift(action.payload.note);
    return {
      ...state,
      notes: newboard,
      message: action.payload.message,
      title: action.payload.title,
      board: true,
      code: "added",
    };
  }
  if (action.type === actionType.ADD_IMAGE_TO_NOTE) {
    const noteadd_to_attachment = [...state.notes];
    const custom_note_uuid = action.payload.custom_note_uuid;
    const find_note_index = noteadd_to_attachment.findIndex(
      (item) => item.custom_note_uuid === custom_note_uuid
    );
    if (action.payload.attachment) {
      noteadd_to_attachment[find_note_index]["attachment"] = {
        ...noteadd_to_attachment[find_note_index].attachment,
        ...action.payload.attachment,
      };
    }
    return { ...state, notes: noteadd_to_attachment };
  } else if (action.type === actionType.BOARD_NOTE_LIST) {
    const newnotes = action.payload.notes;
    let newTransforNotes = newnotes.map((itt) => {
      if (
        itt.attachment &&
        !Array.isArray(itt.attachment) &&
        typeof itt.attachment === "string"
      ) {
        return { ...itt, attachment: JSON.parse(itt.attachment) };
      } else {
        return itt;
      }
    });
    if (action.payload.length !== 0) {
      return {
        ...state,
        notes: newTransforNotes || [],
        // users: action.payload.users || action.payload,
      };
    } else {
      return { ...state, notes: [] };
    }
  } else {
    return state;
  }
};
